import Vue from 'vue'
import RoundedTag from '@/components/kendo/templates/RoundedTag.vue'
import RoundedGroup from '@/components/kendo/templates/RoundedGroup.vue'
import { i18n } from '@/i18n'
import store from '@/store'

let extraTagWidth = null
let extraGroupWidth = null
let extraPropGroupWidth = null
let tagFont = null
let groupFont = null
let canvas = null

function isValid (number) {
  return number !== null && number !== undefined && !isNaN(number)
}

function getExtra (element, { useRectWidth = false, includeFont = true } = {}) {
  var width = 0
  var font = null
  if (element) {
    const rectWidth = (useRectWidth ? element.getBoundingClientRect().width : 0) || 0
    const cs = getComputedStyle(element)
    const pl = parseFloat(cs.paddingLeft) || 0
    const pr = parseFloat(cs.paddingRight) || 0
    const bl = parseFloat(cs.borderLeftWidth) || 0
    const br = parseFloat(cs.borderRightWidth) || 0
    const ml = parseFloat(cs.marginLeft) || 0
    const mr = parseFloat(cs.marginRight) || 0
    
    width = rectWidth + pl + pr + bl + br + ml + mr
    if (includeFont) font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`
  }
  return { width, font }
}

export default function getRoundedTagWidth (text, isGroup = false, groupOptions = { propietario: false }) {
  var extraWidth
  var font
  if (isGroup) {
    if (groupOptions.propietario) text = ` ${text}` 
    if (groupFont !== null && groupFont !== undefined && isValid(extraGroupWidth) && (isValid(extraPropGroupWidth) || !groupOptions.propietario)) {
      extraWidth = extraGroupWidth + (groupOptions.propietario ? extraPropGroupWidth : 0)
      font = groupFont
    } else {
      const group = new (Vue.extend(RoundedGroup))({
        class: 'invisible',
        i18n,
        store,
        propsData: {
          group: { Nombre: 'W', Propietario: true, idTipo: 1 }
        },
      })
      group.$mount()
      document.body.appendChild(group.$el)
      const extraGroup = getExtra(group.$el)
      extraPropGroupWidth = getExtra(group.$el.querySelector('svg[role="img"]'), { useRectWidth: true, includeFont: false }).width
      group.$el.remove()
      group.$destroy()
      extraGroupWidth = extraGroup.width
      groupFont = extraGroup.font
      extraWidth = extraGroupWidth + (groupOptions.propietario ? extraPropGroupWidth : 0)
      font = groupFont
    }
  } else {
    if (tagFont !== null && tagFont !== undefined && extraTagWidth !== null && extraTagWidth !== undefined && !isNaN(extraTagWidth)) {
      extraWidth = extraTagWidth
      font = tagFont
    } else {
      const tag = new (Vue.extend(RoundedTag))({
        class: 'invisible',
        i18n,
        store,
        propsData: {
          tag: 'W'
        }
      })
      tag.$mount()
      document.body.appendChild(tag.$el)
      const extraTag = getExtra(tag.$el)
      tag.$el.remove()
      tag.$destroy()
      extraTagWidth = extraTag.width
      extraWidth = extraTagWidth
      tagFont = extraTag.font
      font = tagFont
    }
  }
  if (!canvas) {
    canvas = document.createElement('canvas')
  }
  const context = canvas.getContext('2d')
  context.font = font
  const textWidth = context.measureText(text).width
  return textWidth + extraWidth
}
